// fix this
/* eslint-disable no-useless-escape */
/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
import Cookies from 'cookie-universal';
import { http } from '@article/pixel';
import UserService from '@/services/UserService';
import useQuery from '@/compositions/useQuery.js';
import useMutation from '@/compositions/useMutation';
import CountryUtils from '@/components/commons/CountryUtils.js';
import LocationService from '@/services/LocationService';
import handlers from './events-handlers.js';
import Tracking from './Tracking.js';
import LocalStorage, { LocalStorageKeys } from './LocalStorage.js';
import Chronicle from '@/components/commons/Chronicle.js';

export function getSessionValue(key) {
  const sessionObject = getCookieObject('ARTICLE_SESSION');
  return sessionObject[key];
}

export function getCookieObject(name) {
  if (!name) {
    return {};
  }

  let cookieContent = Cookies().get(name, { parseJSON: false });

  if (!cookieContent) {
    return {};
  }

  if (/(\'|\")/.test(cookieContent.charAt(0))) {
    cookieContent = cookieContent.substring(1, cookieContent.length - 1);
  }

  const content = cookieContent.substring(cookieContent.indexOf('-') + 1);

  if (!content || content === 'null') {
    return false;
  }

  const object = {};
  content.split('&').forEach((cookie) => {
    const [key, value] = cookie.split('=');
    object[key] = decodeURIComponent(value);
  });

  return object;
}

export function getRequestValue(key) {
  const url = window.location.href;
  const keysValues = url.split(/[\?&]+/);
  for (let i = 0; i < keysValues.length; i++) {
    const keyValue = keysValues[i].split('=');
    if (keyValue[0] === key) {
      return keyValue[1];
    }
  }
  return null;
}

export function getSessionCountry() {
  return CountryUtils.getCountryByCurrencyId(LocationService.getCurrencyId());
}

export function trackEvent(category, action, label, value, extra) {
  if (typeof category !== 'undefined' && typeof action !== 'undefined') {
    handlers.track(category, action, label, value, extra);
  }
}

export function getCartQuantity() {
  const cartItems = UserService.getCart()?.cartItems;
  if (cartItems) {
    if (cartItems.length) {
      let quantity = 0;
      for (let i = 0; i < cartItems.length; i++) {
        quantity += cartItems[i].quantity;
      }
      return quantity;
    }
  }
  return 0;
}

export function getFavoritesQuantity() {
  const favoritesData = LocalStorage.get(LocalStorageKeys.FAVORITES);

  if (favoritesData) {
    const data = JSON.parse(favoritesData);
    return Object.keys(data).length;
  }
  return 0;
}

export function isUser() {
  return isLoggedIn() || isUnverifiedUser();
}

export function isLoggedIn() {
  return UserService.isVerified();
}

export function isUnverifiedUser() {
  return UserService.isRegistered() && !UserService.isVerified();
}

export function checkLoggedIn() {
  if (!isLoggedIn()) {
    return;
  }

  const notLoggedInDom = document.querySelector('.account-link .not-logged-in');
  const loggedInDom = document.querySelector('.account-link .logged-in');
  if (notLoggedInDom && loggedInDom) {
    notLoggedInDom.classList.add('hidden');
    loggedInDom.classList.remove('hidden');
  }

  const accountMobileLinkContainer = document.querySelector('.account-mobile-link');
  if (accountMobileLinkContainer) {
    accountMobileLinkContainer.innerHTML = `<a href="/account"><p class="text">My Account</p></a>`;
  }
}

async function updateFavorites() {
  try {
    const result = await http.get('/api/wishlist/all');

    if (result && result.success) {
      if (result.favorite) {
        const data = {};
        result.favorite.forEach((value) => {
          data[value] = 1;
        });

        if (data && Object.keys(data)) {
          LocalStorage.set(LocalStorageKeys.FAVORITES, JSON.stringify(data));
        } else {
          LocalStorage.remove(LocalStorageKeys.FAVORITES);
        }
        LocalStorage.set(LocalStorageKeys.FAVORITE_TIME, new Date().getTime());
      }
    }
  } catch (error) {
    Tracking.sentryCaptureError(error);
  }
}

export async function updateFavoriteHeader(force = false) {
  if (!isUser()) {
    LocalStorage.remove(LocalStorageKeys.FAVORITES);
    LocalStorage.remove(LocalStorageKeys.FAVORITE_TIME);
    return;
  }

  const favoritesTime = LocalStorage.get(LocalStorageKeys.FAVORITE_TIME);
  if (force || !favoritesTime || new Date().getTime() - favoritesTime > 3.6e6) {
    await updateFavorites();
  }
}

export const importScript = (url, attributes) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.addEventListener('load', () => {
      resolve();
    });

    script.addEventListener('error', () => {
      reject(new Error(`Import script (${url}) returned an error while loading.`));
    });

    script.src = url;
    script.async = true;
    script.type = 'text/javascript';

    if (attributes) {
      Object.keys(attributes, (attribute) => {
        script[attribute] = attributes[attribute];
      });
    }

    const body = document.getElementsByTagName('body')[0];
    if (body) {
      body.insertBefore(script, body.firstChild);
    } else {
      reject(new Error(`Import script (${url}) failed. Could not insert into the document body.`));
    }

    return script;
  });

export const getScrollBarWidth = () => {
  const scrollBarMeasureDiv = document.createElement('div');
  scrollBarMeasureDiv.classList.add('scroll-bar-measure');
  document.body.appendChild(scrollBarMeasureDiv);
  const width = scrollBarMeasureDiv.getBoundingClientRect().width - scrollBarMeasureDiv.clientWidth;
  document.body.removeChild(scrollBarMeasureDiv);
  return width;
};

export const validateEmail = (email) => {
  if (!email) {
    return false;
  }
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
};

export function isTouch() {
  return 'ontouchstart' in document.documentElement;
}

export function getNewNavigationTestCondition() {
  if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'uat') {
    return true;
  }
  if (process.env.NODE_ENV === 'test') {
    return false;
  }

  const experiment = LocalStorage.get(LocalStorageKeys.NEW_NAVIGATION);

  if (experiment) {
    try {
      const { enabled } = JSON.parse(experiment);
      return enabled;
    } catch (error) {
      Tracking.sentryCaptureError(error);
    }
  }

  const enabled = !!Math.floor(Math.random() * 2);

  LocalStorage.set(LocalStorageKeys.NEW_NAVIGATION, JSON.stringify({ enabled }));

  Tracking.track('NEW_NAV_ENABLED', { enabled });

  return enabled;
}

export function browseRoomPageTestCondition() {
  return true;
}

export function getSimpleABTestingCondition(testName) {
  const testsJson = LocalStorage.get(LocalStorageKeys.AB_TESTS);
  let tests;
  if(testsJson) {
    tests = JSON.parse(testsJson);
    if(tests && typeof (tests[testName]) === 'boolean') {
      return tests[testName];
    }
  }else{
    tests = {};
  }

  if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'uat' || process.env.NODE_ENV === 'test') {
    tests[testName] = true;
  } else {
    tests[testName] = !!Math.floor(Math.random() * 2);
  }
  Tracking.track(testName, { enabled: tests[testName] });
  LocalStorage.set(LocalStorageKeys.AB_TESTS, JSON.stringify(tests));
  return tests[testName];
}

// min and max inclusive
function getRandomNum(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// 0 = control
// 1 = limited image tags && productListModal
// 2 = no image tags && productListModal
export function getImageTaggingTestVariant() {
  return 1;
}

export function executeQuery(query, variables, options) {
  return new Promise((resolve, reject) => {
    const { onResult, onError } = useQuery(query, variables, options);

    onResult((data) => {
      resolve(data);
    });

    onError((error) => {
      reject(error);
    });
  });
}

export function executeMutation(mutation, variables) {
  return new Promise((resolve, reject) => {
    const { mutate, onDone, onError } = useMutation(mutation);
    mutate(variables);

    onDone(({ data }) => {
      resolve(data);
    });

    onError((error) => {
      reject(error);
    });
  });
}

export function scrollTop() {
  window &&
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
}

/**
 * In an effort to move away from lodash, here we are defining a
 * replacement for lodash's debounce function.
 */
export function debounce(func, wait) {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
